export default {
  //get all CHAPTERs
  GET_SUPERADMIN_SECTIONS_REQUEST: "GET_SUPERADMIN_SECTIONS_REQUEST",
  GET_SUPERADMIN_SECTIONS_SUCCESS: "GET_SUPERADMIN_SECTIONS_SUCCESS",
  GET_SUPERADMIN_SECTIONS_FAIL: "GET_SUPERADMIN_SECTIONS_FAIL",

  //edit CHAPTERs
  EDIT_SUPERADMIN_SECTION_REQUEST: "EDIT_SUPERADMIN_SECTION_REQUEST",
  EDIT_SUPERADMIN_SECTION_SUCCESS: "EDIT_SUPERADMIN_SECTION_SUCCESS",
  EDIT_SUPERADMIN_SECTION_FAIL: "EDIT_SUPERADMIN_SECTION_FAIL",

  RESTRICT_SUPERADMIN_SECTION_REQUEST: "RESTRICT_SUPERADMIN_SECTION_REQUEST",
  RESTRICT_SUPERADMIN_SECTION_SUCCESS: "RESTRICT_SUPERADMIN_SECTION_SUCCESS",
  RESTRICT_SUPERADMIN_SECTION_FAIL: "RESTRICT_SUPERADMIN_SECTION_FAIL",

  ASQUARA_SUPERADMIN_SECTION_REQUEST: "ASQUARA_SUPERADMIN_SECTION_REQUEST",
  ASQUARA_SUPERADMIN_SECTION_SUCCESS: "ASQUARA_SUPERADMIN_SECTION_SUCCESS",
  ASQUARA_SUPERADMIN_SECTION_FAIL: "ASQUARA_SUPERADMIN_SECTION_FAIL",
  ACTIVE_SUPERADMIN_SECTION_REQUEST: "ACTIVE_SUPERADMIN_SECTION_REQUEST",
  ACTIVE_SUPERADMIN_SECTION_SUCCESS: "ACTIVE_SUPERADMIN_SECTION_SUCCESS",
  ACTIVE_SUPERADMIN_SECTION_FAIL: "ACTIVE_SUPERADMIN_SECTION_FAIL",

  //create CHAPTER
  CREATE_SUPERADMIN_SECTION_REQUEST: "CREATE_SUPERADMIN_SECTION_REQUEST",
  CREATE_SUPERADMIN_SECTION_SUCCESS: "CREATE_SUPERADMIN_SECTION_SUCCESS",
  CREATE_SUPERADMIN_SECTION_FAIL: "CREATE_SUPERADMIN_SECTION_FAIL",

  DELETE_SUPERADMIN_SECTION_REQUEST: "DELETE_SUPERADMIN_SECTION_REQUEST",
  DELETE_SUPERADMIN_SECTION_SUCCESS: "DELETE_SUPERADMIN_SECTION_SUCCESS",
  DELETE_SUPERADMIN_SECTION_FAIL: "DELETE_SUPERADMIN_SECTION_FAIL",

  GET_SUPERADMIN_SECTION_REQUEST: "GET_SUPERADMIN_SECTION_REQUEST",
  GET_SUPERADMIN_SECTION_SUCCESS: "GET_SUPERADMIN_SECTION_SUCCESS",
  GET_SUPERADMIN_SECTION_FAIL: "GET_SUPERADMIN_SECTION_FAIL",

  SUPERADMIN_GET_COURSE_SECTION_REQUEST:
    "SUPERADMIN_GET_COURSE_SECTION_REQUEST",
  SUPERADMIN_GET_COURSE_SECTION_SUCCESS:
    "SUPERADMIN_GET_COURSE_SECTION_SUCCESS",
  SUPERADMIN_GET_COURSE_SECTION_FAIL: "SUPERADMIN_GET_COURSE_SECTION_FAIL",

  //loading
  ADD_SUPERADMIN_SECTIONS_LOADING: "ADD_SUPERADMIN_SECTIONS_LOADING",
};
